import NodeEvents from 'events';
import * as Inovx from '@shared';
import LicenseConstants from '../constants/LicenseConstants';

var EventEmitter = NodeEvents.EventEmitter;
var DateTimeFormatHelper = Inovx.Shared.Common.DateTimeFormatHelper;

var CHANGE_EVENT = 'License.change';

var _beginAdd = false,
    _modalVisible = false,
    _licenseChangesMade = false,
    _license: License = getBlankLicense(),
    _editLicense: string = "",
    _allLicenses: License[] = [];

function getBlankLicense() {
    return { ID: "", StartDate: "", ExpirationDate: "", KnowledgeViewLimit: 0, AssetLimit: 0, CompanyName: "", PurchaseOrder: "", IsExpired: false, DisplayName: "" };
}

function setAddingLicense() {
    _beginAdd = _modalVisible = true;
    _licenseChangesMade = false;
    _editLicense = "";
}

function updateAddingLicense(key: string, value: string) {
    _editLicense = value;
    _licenseChangesMade = true;
}
function licenseFinishedAdding() {
    _modalVisible = false;
    _licenseChangesMade = false;
}

function fixLicense(license: License) {
    if (license) {
        license.StartDate = DateTimeFormatHelper.getFormatDate(license.StartDate);
        license.ExpirationDate = DateTimeFormatHelper.getFormatDate(license.ExpirationDate);
    }
}

function fixLicenses(data: License[]) {
    if (data) {
        data.forEach((l) => {
            fixLicense(l);
        });
    }
}


var LicenseStore = Object.assign({}, EventEmitter.prototype, {
    getCurrentLicense() {
        return _license;
    },
    getAllLicenses() {
        return _allLicenses;
    },
    getEditLicense() {
        return _editLicense;
    },
    getHasChanges() {
        return _licenseChangesMade;
    },
    getModalVisible() {
        return _modalVisible;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload: any) {
    switch (payload.actionType) {
        case LicenseConstants.LICENSE_GET_ALL:
            _allLicenses = payload.data;
            fixLicenses(_allLicenses);
            break;
        case LicenseConstants.LICENSE_GET_INFO:
            _license = payload.data;
            fixLicense(_license);
            break;
        case LicenseConstants.LICENSE_BEGIN_ADD:
            setAddingLicense();
            break;
        case LicenseConstants.LICENSE_ADD_UPDATE:
            updateAddingLicense(payload.key, payload.value);
            break;
        case LicenseConstants.LICENSE_FINISH_ADD:
            licenseFinishedAdding();
            break;
        default: return true;
    }

    LicenseStore.emitChange();

    return true;
});

export default LicenseStore;
